import * as React from 'react';
const Index = ({ width = 16, height = 16, color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    color={color ? color : '#5EC4AC'}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.053 5.72v4.56c0 .747-.4 1.44-1.046 1.82l-3.96 2.287a2.108 2.108 0 0 1-2.1 0L2.987 12.1a2.1 2.1 0 0 1-1.047-1.82V5.72c0-.747.4-1.44 1.047-1.82l3.96-2.287a2.109 2.109 0 0 1 2.1 0l3.96 2.287a2.108 2.108 0 0 1 1.046 1.82Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 7.333a1.553 1.553 0 1 0 0-3.106 1.553 1.553 0 0 0 0 3.106ZM10.667 11.107c0-1.2-1.194-2.174-2.667-2.174-1.473 0-2.667.974-2.667 2.174"
    />
  </svg>
);
export default Index;
